<script setup>
import { useAssistenciaTecnicaStore } from '@/stores/assistenciaTecnica';
import KanbanColumn from '@/components/common/KanbanColumn.vue';
import AssistenciaTecnicaCard from './AssistenciaTecnicaCard.vue';

const props = defineProps({
  column: {
    type: Object,
    required: true
  }
});

const assistenciaStore = useAssistenciaTecnicaStore();

// Handle when bottom of column is reached
const handleLoadMore = (columnKey) => {
  console.log(`Carregando mais para coluna ${columnKey}`);
  assistenciaStore.loadMoreForColumn(columnKey);
};
</script>

<template>
  <KanbanColumn
    :column="props.column"
    :items="assistenciaStore.getAssistenciasByStatus(props.column.key)"
    :loading="assistenciaStore.isColumnLoading(props.column.key)"
    :has-more-to-load="assistenciaStore.hasMoreToLoad(props.column.key)"
    :column-total="assistenciaStore.getColumnTotal(props.column.key)"
    loading-text="Carregando assistências..."
    loading-more-text="Carregando mais assistências..."
    empty-text="Nenhuma assistência técnica neste status"
    end-text="Fim da lista"
    @load-more="handleLoadMore"
  >
    <template #default="{ items }">
      <AssistenciaTecnicaCard
        v-for="assistencia in items"
        :key="`${assistencia.id}-${assistencia.updated_at || Date.now()}`"
        :assistencia="assistencia"
      />
    </template>
  </KanbanColumn>
</template>
